var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-empty-pattern */
import { Button, createTheme, Divider, MuiThemeProvider, Tooltip, } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Close, Save } from '@material-ui/icons';
import { Form, Formik } from 'formik';
import PubSub from 'pubsub-js';
import React, { useEffect, useState } from 'react';
import { baseURL, config_baseURL, set_config_baseURL } from '../../../../api';
import { accounts } from '../../../../frontend-config';
import { PacingForm } from '../../../CampaignView/CampaignConfigurator/PacingForm';
import { AccountSelector } from '../../../commons/AccountSelector';
import { campaignOversightFormInitialValues } from '../../../commons/assets/InitialValues';
import { CustomTextField } from '../../../commons/CustomTextField';
import { getDateFromString, getTimeDuration, toTime, } from '../../../commons/utils/DateFormatter';
import { campaignOversightFormValidationSchema } from '../../../commons/validation/CampaignOversightValidation';
import { Title } from '../CampaignOversightLogs/CampaignOversightLogs.Styles';
import { ButtonWrapper, ConfigWrapper, LeftWrapper, PacingBodyWrapper, PacingHeaderWrapper, RightWrapper, Wrapper, } from './CampaignOversightForm.Styles';
var theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2'
        },
        secondary: {
            main: '#FF4136'
        }
    }
});
export var CampaignOversightForm = function (_a) {
    var selectedRow = _a.selectedRow, controlScheduleExecution = _a.controlScheduleExecution, onDiscardClick = _a.onDiscardClick, dialerDefaults = _a.dialerDefaults, onAccountChange = _a.onAccountChange, schedules = _a.schedules;
    var _b = useState(true), readOnly = _b[0], setReadOnly = _b[1];
    var _c = useState(false), openAlert = _c[0], setOpenAlert = _c[1];
    var _d = useState(selectedRow), selectedScheduleExecution = _d[0], setSelectedScheduleExecution = _d[1];
    var _e = useState(), configAccount = _e[0], setConfigAccount = _e[1];
    var handleClose = function () {
        setOpenAlert(false);
    };
    useEffect(function () {
        PubSub.unsubscribe('campaign_oversight_pane_status');
        PubSub.subscribe('campaign_oversight_pane_status', function (topic, msg) {
            if (msg === false && !readOnly) {
                setOpenAlert(true);
                PubSub.publish('campaign_oversight_form_status', false);
            }
            else {
                PubSub.publish('campaign_oversight_form_status', true);
            }
        });
    }, [readOnly]);
    var handleConfirmation = function (submitForm) {
        submitForm();
        handleClose();
    };
    var handleDiscard = function (setValues, values) {
        setFormValues(setValues, values);
        setReadOnly(true);
        onDiscardClick();
        setSelectedScheduleExecution(null);
    };
    var handleSubmit = function (submitForm) {
        submitForm();
    };
    useEffect(function () {
        setSelectedScheduleExecution(selectedRow);
        if (selectedRow && selectedRow.prjacc) {
            setConfigAccount(accounts.find(function (a) { return a.url === selectedRow.prjacc.url; }));
            set_config_baseURL(selectedRow.prjacc.url);
            onAccountChange(selectedRow.prjacc.url);
        }
        else if (selectedRow && JSON.stringify(selectedRow) !== '{}') {
            setConfigAccount(accounts.find(function (a) { return a.url === baseURL(); }));
            onAccountChange(baseURL());
            set_config_baseURL(baseURL());
        }
        else {
            setConfigAccount(accounts.find(function (a) { return a.url === config_baseURL(); }));
            onAccountChange(config_baseURL());
        }
    }, [selectedRow]);
    var setFormValues = function (setValues, values) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        console.log(selectedScheduleExecution, '$$ schedule execution');
        var overridePacing = (_b = (_a = schedules.find(function (sched) { return sched.id === (selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.ScheduleId); })) === null || _a === void 0 ? void 0 : _a.PacingOverride) === null || _b === void 0 ? void 0 : _b.ConcurrentCalls;
        setValues(__assign(__assign({ initialCallsPerAgent: ((_c = selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.Pacing) === null || _c === void 0 ? void 0 : _c.InitialCPA) || 0, initialCpaMode: ((_d = selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.Pacing) === null || _d === void 0 ? void 0 : _d.InitialCPAMode) || '', maxPerAgent: ((_e = selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.Pacing) === null || _e === void 0 ? void 0 : _e.MaxCPA) || 0, initialPacing: ((_f = selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.Pacing) === null || _f === void 0 ? void 0 : _f.InitialDuration) || 0, aBAIncrement: ((_g = selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.Pacing) === null || _g === void 0 ? void 0 : _g.AbaIncrement) || 0, cPAModifier: ((_h = selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.Pacing) === null || _h === void 0 ? void 0 : _h.CpaModifier) || 0, aBACalculation: ((_j = selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.Pacing) === null || _j === void 0 ? void 0 : _j.AbaCalculation) || '', aBATargetRate: ((_k = selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.Pacing) === null || _k === void 0 ? void 0 : _k.AbaTargetRate) || 0 }, ((selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.CampaignMode) === 'agentless' && ((_l = selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.PacingOverride) === null || _l === void 0 ? void 0 : _l.ConcurrentCalls) &&
            ((_m = selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.PacingOverride) === null || _m === void 0 ? void 0 : _m.ConcurrentCalls) != null &&
            ((_o = selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.PacingOverride) === null || _o === void 0 ? void 0 : _o.ConcurrentCalls) !== NaN && {
            concurrentCalls: ((_p = selectedScheduleExecution.Pacing) === null || _p === void 0 ? void 0 : _p.ConcurrentCalls) || 0
        })), { 
            // concurrentCalls: selectedScheduleExecution?.Pacing?.ConcurrentCalls || 0,
            concurrentCalls: ((_q = selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.Pacing) === null || _q === void 0 ? void 0 : _q.ConcurrentCalls) || overridePacing, weight: (selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.CampaignWeight) || 0, endTime: toTime(new Date((selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.EndTime) || 0)) }));
    };
    var onSend = function (value, resetForm) {
        var oldEndDate = new Date((selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.EndTime) || 0);
        var startDate = new Date((selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.StartTime) || 0);
        var newEndDate = getDateFromString(oldEndDate, (value === null || value === void 0 ? void 0 : value.endTime) || '00:00');
        var runtimeParameters = (selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.CampaignMode) === 'power'
            ? {
                pacing: {
                    InitialCPAMode: value === null || value === void 0 ? void 0 : value.initialCpaMode,
                    MaxCPA: value === null || value === void 0 ? void 0 : value.maxPerAgent,
                    AbaCalculation: value === null || value === void 0 ? void 0 : value.aBACalculation,
                    AbaIncrement: value === null || value === void 0 ? void 0 : value.aBAIncrement,
                    AbaTargetRate: value === null || value === void 0 ? void 0 : value.aBATargetRate,
                    CpaModifier: value === null || value === void 0 ? void 0 : value.cPAModifier,
                    InitialCPA: value === null || value === void 0 ? void 0 : value.initialCallsPerAgent,
                    InitialDuration: value === null || value === void 0 ? void 0 : value.initialPacing,
                    ConcurrentCalls: value === null || value === void 0 ? void 0 : value.concurrentCalls
                },
                weight: value === null || value === void 0 ? void 0 : value.weight,
                duration: Math.floor(getTimeDuration(startDate, newEndDate) / 60000) || 0
            }
            : {
                pacing: {
                    AbaIncrement: value === null || value === void 0 ? void 0 : value.aBAIncrement,
                    AbaTargetRate: value === null || value === void 0 ? void 0 : value.aBATargetRate,
                    CpaModifier: value === null || value === void 0 ? void 0 : value.cPAModifier,
                    InitialCPA: value === null || value === void 0 ? void 0 : value.initialCallsPerAgent,
                    InitialDuration: value === null || value === void 0 ? void 0 : value.initialPacing,
                    ConcurrentCalls: value === null || value === void 0 ? void 0 : value.concurrentCalls
                },
                weight: value === null || value === void 0 ? void 0 : value.weight,
                duration: Math.floor(getTimeDuration(startDate, newEndDate) / 60000) || 0
            };
        if (selectedScheduleExecution) {
            controlScheduleExecution('UPDATE_RUNTIME_PARAMETERS', selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.ScheduleExecutionId, function (data) {
                setReadOnly(true);
                localStorage.setItem('onEditMode', '0');
            }, runtimeParameters);
        }
    };
    return (React.createElement(MuiThemeProvider, { theme: theme },
        React.createElement(Wrapper, null,
            React.createElement(LeftWrapper, null,
                React.createElement(ConfigWrapper, null,
                    React.createElement(AccountSelector, { initialValue: configAccount, onValueChange: function (account) {
                            if (account && account !== 'All') {
                                setConfigAccount(account);
                                onAccountChange(account.url);
                                set_config_baseURL(account.url);
                            }
                        }, fullWidth: true, noAll: true, disabled: true })),
                React.createElement(Divider, null),
                React.createElement(Formik, { initialValues: campaignOversightFormInitialValues, validationSchema: campaignOversightFormValidationSchema(dialerDefaults, selectedScheduleExecution), onSubmit: function (values, _a) {
                        var setSubmitting = _a.setSubmitting, resetForm = _a.resetForm;
                        setSubmitting(false);
                        onSend(values, resetForm);
                    } }, function (_a) {
                    var submitForm = _a.submitForm, isSubmitting = _a.isSubmitting, values = _a.values, setValues = _a.setValues, errors = _a.errors;
                    return (React.createElement(Form, null,
                        useEffect(function () {
                            setTimeout(function () {
                                setFormValues(setValues, values);
                            }, 400);
                        }, [selectedScheduleExecution]),
                        React.createElement(PacingHeaderWrapper, null,
                            React.createElement(Title, null, "Pacing")),
                        React.createElement(PacingBodyWrapper, { isReadOnly: readOnly },
                            React.createElement(PacingForm, { isScheduleExecution: true, oversightMode: selectedScheduleExecution === null || selectedScheduleExecution === void 0 ? void 0 : selectedScheduleExecution.CampaignMode, 
                                // isCampaignConfig={false}
                                formValues: values, errors: errors }),
                            React.createElement("br", null),
                            React.createElement(CustomTextField, { name: 'endTime', label: 'End Time', type: 'time', fullWidth: true })),
                        React.createElement(ButtonWrapper, null, readOnly ? (React.createElement(React.Fragment, null,
                            React.createElement(Button, { variant: 'contained', color: 'secondary', onClick: function () {
                                    setReadOnly(false);
                                    localStorage.setItem('onEditMode', '1');
                                } }, "Override Pacing"))) : (React.createElement(React.Fragment, null,
                            React.createElement(Tooltip, { title: 'Save Changes' },
                                React.createElement(Button, { variant: 'contained', color: 'primary', onClick: function () {
                                        handleSubmit(submitForm);
                                    } },
                                    React.createElement(Save, null))),
                            React.createElement(Tooltip, { title: 'Discard Changes' },
                                React.createElement(Button, { variant: 'contained', color: 'secondary', onClick: function () { return handleDiscard(setValues); } },
                                    React.createElement(Close, null)))))),
                        React.createElement(Dialog, { open: openAlert, onClose: function () {
                                handleClose();
                                // handlePaneClose();
                            }, "aria-labelledby": 'alert-delete', "aria-describedby": 'alert-dialog-description' },
                            React.createElement(DialogTitle, { id: 'alert-delete' }, "Unsaved Configuration"),
                            React.createElement(DialogContent, null,
                                React.createElement(DialogContentText, { id: 'alert-dialog-description' }, "Do you want to save the configuration before closing?")),
                            React.createElement(DialogActions, null,
                                React.createElement(Button, { onClick: function () {
                                        handleClose();
                                    }, color: 'primary' }, "No"),
                                React.createElement(Button, { onClick: function () {
                                        handleConfirmation(submitForm);
                                    }, color: 'primary', autoFocus: true }, "Yes")))));
                })),
            React.createElement(RightWrapper, null))));
};
CampaignOversightForm.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=CampaignOversightForm.js.map